import React from 'react';
import styled from 'styled-components';
import { 
  FaDraftingCompass, 
  FaHardHat, 
  FaBook, 
  FaFlask 
} from 'react-icons/fa';
import SectionHeader from '../common/SectionHeader';

const ProgramsSection = styled.section`
  background-color: ${props => props.theme.colors.white};
  padding: 80px 0;
`;

const ProgramsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 30px;
`;

const ProgramCard = styled.div`
  padding: 30px;
  background-color: ${props => props.theme.colors.lightColor};
  border-radius: 8px;
  text-align: center;
  transition: ${props => props.theme.transitions.main};
  box-shadow: ${props => props.theme.shadows.regular};
  
  &:hover {
    transform: translateY(-10px);
    box-shadow: ${props => props.theme.shadows.large};
  }
`;

const ProgramIcon = styled.div`
  font-size: 2.5rem;
  color: ${props => props.theme.colors.primaryColor};
  margin-bottom: 20px;
`;

const ProgramTitle = styled.h3`
  font-size: ${props => props.theme.fontSizes.large};
  margin-bottom: 15px;
  color: ${props => props.theme.colors.secondaryColor};
`;

const ProgramDescription = styled.p`
  color: ${props => props.theme.colors.grey[600]};
`;

const Programs = () => {
  const programsData = [
    {
      id: 1,
      title: 'Structural Design',
      description: 'Learn advanced structural design concepts and methodologies for various types of structures.',
      icon: <FaDraftingCompass />
    },
    {
      id: 2,
      title: 'Civil Engineering',
      description: 'Comprehensive courses covering various aspects of civil engineering theory and practice.',
      icon: <FaHardHat />
    },
    {
      id: 3,
      title: 'Exam Preparation',
      description: 'Specialized coaching for competitive exams including TNPSC technical services.',
      icon: <FaBook />
    },
    {
      id: 4,
      title: 'Research Projects',
      description: 'Participate in cutting-edge research projects in the field of structural engineering.',
      icon: <FaFlask />
    }
  ];

  return (
    <ProgramsSection>
      <div className="container">
        <SectionHeader 
          title="Our Programs" 
          subtitle="Discover our comprehensive range of programs designed for aspiring engineers" 
        />
        
        <ProgramsGrid>
          {programsData.map(program => (
            <ProgramCard key={program.id}>
              <ProgramIcon>{program.icon}</ProgramIcon>
              <ProgramTitle>{program.title}</ProgramTitle>
              <ProgramDescription>{program.description}</ProgramDescription>
            </ProgramCard>
          ))}
        </ProgramsGrid>
      </div>
    </ProgramsSection>
  );
};

export default Programs;
